import { createFileRoute } from '@tanstack/react-router';
import { PaymentRequestsPage } from '../../features/billing-docs';

export const Route = createFileRoute('/portal/payment-requests/')({ component: PaymentRequestsPage });
